import auth from '@/services/auth'

const user = {
  update: async function (onboarded) {
    try {
      // Create data
      var data = {}
      if (onboarded !== '') data.onboarded = onboarded

      // Send
      const resp = await auth.sendWithToken({
        method: 'patch',
        url: '/v1/user',
        data: data
      })

      // Handle resp
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  contact: async function (message) {
    try {
      // Send
      const resp = await auth.sendWithToken({
        method: 'post',
        url: '/v1/user/contact',
        data: {
          message: message
        }
      })

      // Handle resp
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  uploadFile: async function (f, name, category) {
    try {
      // Create form data
      const d = new FormData()
      d.append('file', f)
      if (category) d.append('category', category)
      if (name) d.append('name', name)

      // Send
      const resp = await auth.sendWithToken({
        method: 'post',
        url: '/v1/storage/files',
        data: d
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  updateFile: async function (id, name) {
    try {
      // Create data
      var data = {}
      if (name !== '') data.name = name

      // Send
      const resp = await auth.sendWithToken({
        method: 'patch',
        url: '/v1/storage/files/' + id,
        data: data
      })

      // Handle resp
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  removeFile: async function (id) {
    try {
      // Send
      const resp = await auth.sendWithToken({
        method: 'delete',
        url: '/v1/storage/files/' + id
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  me: async function () {
    try {
      const resp = await auth.sendWithToken({
        method: 'get',
        url: '/v1/me'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

export default user
